export const tinymcekey = 'z03h26su0jaashj0krx7cr3tovic1om2ziizzedmsydiypgv'
// export const settings = {
//     some: 'Settings'
// }
